import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Base from '../Base';
import Deflector from './Deflector';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))

function ShotSavedEvent({event, teams, players, periods}) {
  const classes = useStyles();
  const { result } = event;
  const period = periods[event.period].name;
  const shooter = players[event.player];
  const team = teams[shooter.team].id;
  const deflector = event.deflect && players[event.deflect.player];

  const goalie = players[result.player];
  const isRebound = result.isRebound;

  return (
    <Base
      time={event.second}
      period={period}
      team={team}
      type={`${deflector ? 'Deflected ' : ''}Shot on Goal`}
    >
      <Typography variant="body2">
        Shot by{' '}
        <span className={classes.bold}>{shooter.name}</span>
        <Deflector deflector={deflector} />
        {' '}is stopped by{' '}
        <span className={classes.bold}>{goalie.name}</span>
        {isRebound ? ' with ' : ' without '}
        a rebound.
      </Typography>
    </Base>
  )
}

export default ShotSavedEvent;
